import { FrequentPassageRequest } from '@legacy-types';

import { approveFrequentPassageRequest } from '@shared/frequent-passage-requests/endpoints/approveFrequentPassageRequest';
import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';
import { useToast } from '@shared/ui/components/Toast';
import { Tooltip } from '@shared/ui/components/Tooltip';

type ApproveFrequentPassageRequestButtonProps = {
  frequentPassageRequest: FrequentPassageRequest;
  onApprove?: (frequentPassageRequest: FrequentPassageRequest) => void;
};

export function ApproveFrequentPassageRequestButton({
  frequentPassageRequest,
  onApprove,
}: ApproveFrequentPassageRequestButtonProps) {
  const { toast } = useToast();

  function handleApprove() {
    approveFrequentPassageRequest(frequentPassageRequest).then(onApprove);

    toast({
      title: 'Success',
      description: 'Frequent Passage Request approved.',
    });
  }

  const canApprove =
    frequentPassageRequest.canApprove &&
    (frequentPassageRequest.status === 'pending' || frequentPassageRequest.status === 'rejected');

  const button = (
    <Button variant="success" size="sm" onClick={handleApprove} disabled={!canApprove}>
      <Icon icon="check" /> Approve
    </Button>
  );

  if (frequentPassageRequest.frequentPassageStickerType.availability === 0) {
    return (
      <Tooltip
        content={
          frequentPassageRequest.frequentPassageStickerType.availability === 0
            ? 'This sticker type is no longer available.'
            : undefined
        }
      >
        {button}
      </Tooltip>
    );
  }

  return button;
}
